import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface InfoRowProps {
  label: string;
  value: React.ReactNode;
}

export const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1,
      }}
    >
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontWeight: 600 }}>
        {label}:
      </Typography>
      <Typography
        component="span"
        variant="body2"
        sx={{ fontWeight: 600, color: theme.palette.text.primary, textAlign: 'right' }}
      >
        {value || '-'}
      </Typography>
    </Box>
  );
};
